import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "customValidationError", "dataKey", "help", "labelOverride"];
import { useInputValidation } from '../signup-data/useInputValidation';
import { useSignupData } from '../signup-data/useSignupData';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { useInputProps } from '../signup-data/useInputProps';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export const FormControlLabel = ({
  label
}) => {
  return /*#__PURE__*/_jsx(Text, {
    as: "span",
    typography: "body-200",
    children: label
  });
};
const SignupFormControl = _ref => {
  let {
      children,
      customValidationError,
      dataKey,
      help,
      labelOverride
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isInvalid
  } = useSignupData(dataKey);
  const inputProps = useInputProps(dataKey);
  const {
    getValidationText
  } = useInputValidation({
    dataKey,
    customValidationError
  });
  const label = FormControlLabel({
    label: labelOverride !== null && labelOverride !== void 0 ? labelOverride : inputProps.label
  });
  return /*#__PURE__*/_jsx(FormControl, Object.assign({
    "data-data-key": dataKey,
    error: isInvalid,
    help: help,
    label: label,
    validationMessage: getValidationText()
  }, props, {
    children: children
  }));
};
export default SignupFormControl;